export const actions = {
    set: 'SET::CREATE_PROJECT_PERIOD'
  }

  export const setCreateProjectPeriod = projectPeriod => ({ type: actions.set, createProjectPeriod: projectPeriod })
  export const getCreateProjectPeriod = state => state.createProjectPeriod
  
  export default actions